import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss';
import { TonConnectButton, useTonAddress, useTonConnectUI } from "@tonconnect/ui-react";
import { walletShorter } from "../../helpers/walletShorter";
import {useDispatch, useSelector} from "react-redux";
import {
    changePassword,
    changePasswordFailure,
    changePasswordSuccess,
    sendConnectedWallet,
    setSettingsAvatarModalStatus
} from "../../store/cabinet/action";

import user_icon from "../../theme/assets/other/ftf_user_icon_d.png";
import changeBtn from '../../theme/assets/svg/ftf_avatar_btn.svg';
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const CabinetSettingsMain = () => {
    const dispatch = useDispatch();
    const userFriendlyAddress = useTonAddress();
    const [tonConnectUI] = useTonConnectUI();
    const { t } = useTranslation();

    const userData = useSelector(store => store.cabinet.userData);
    const changePasswordStatus = useSelector(store => store.cabinet.changePasswordStatus);
    const formErr = useSelector(store => store.cabinet.changePasswordStatusErr);

    const [current_password, setCurrent_password] = useState('');
    const [new_password, setNew_password] = useState('');

    const isChangePasswordSuccess = () =>{
        return userData?.user?.password_set && current_password.length > 6 && new_password.length > 6
    }

    const changePasswordHandler = () =>{
        if (isChangePasswordSuccess()){
            dispatch(changePassword({current_password, new_password, new_password_confirmation: new_password}))
        }
    }

    useEffect(() => {
        if (changePasswordStatus){
            setNew_password('');
            setCurrent_password('');
            toast(t('Ваш пароль был успешно изменен!'));
            dispatch(changePasswordSuccess(false));
        }
    }, [changePasswordStatus, dispatch, t]);

    useEffect(() => {
        if (userFriendlyAddress) {
            dispatch(sendConnectedWallet(userFriendlyAddress));
        }
    }, [dispatch, userFriendlyAddress]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Настройки')}</div>
                <div className={`${Styles.posWrap}`}>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Сменить аватар')}</div>
                            <div className={`${Styles.avatarWrap}`}>
                                <div className={`${Styles.avatarBox}`}>
                                    <img className={`${Styles.avatarImg}`} src={userData?.user?.avatar ? userData?.user?.avatar : user_icon} alt={userData?.user?.username}/>
                                    <div className={`${Styles.absChangeBtn}`} onClick={()=>{dispatch(setSettingsAvatarModalStatus(true))}}>
                                        <img src={changeBtn} alt="Change avatar"/>
                                    </div>
                                </div>
                                <div className={`${Styles.userBox}`}>
                                    <div className={`${Styles.userBoxItem}`}>
                                        <div className={`${Styles.userBoxItemName}`}>{t('Ваш никнейм')}:</div>
                                        <div className={`${Styles.userBoxItemValue}`}>{userData?.user?.username ?? ''}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Сменить пароль')}</div>
                            <div className={`${Styles.inputsWrap}`}>
                                <div className={`${Styles.inputBox} ${formErr?.current_password ? Styles.inputBoxWithErr : null}`}>
                                    <div className={`${Styles.inputBoxTitle}`}>{t('Старый пароль')}:</div>
                                    <input
                                        type="password"
                                        className={`${Styles.ftfBorderInput}`}
                                        placeholder="********"
                                        onChange={(e)=>{setCurrent_password(e.target.value)}}
                                        value={current_password}
                                        disabled={!userData?.user?.password_set}
                                        onKeyDown={(event)=>{
                                            if (formErr.current_password){
                                                delete formErr.current_password;
                                                dispatch(changePasswordFailure(formErr));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.inputErr}`}>{formErr?.current_password?.[0] ? formErr.current_password[0] : null}</div>
                                </div>
                                <div className={`${Styles.inputBox} ${Styles.inputBoxLast} ${formErr?.new_password ? Styles.inputBoxWithErr : null}`}>
                                    <div className={`${Styles.inputBoxTitle}`}>{t('Новый пароль')}:</div>
                                    <input
                                        type="password"
                                        className={`${Styles.ftfBorderInput}`}
                                        placeholder="********"
                                        onChange={(e)=>{setNew_password(e.target.value)}}
                                        value={new_password}
                                        disabled={!userData?.user?.password_set}
                                        onKeyDown={(event)=>{
                                            if (formErr.new_password){
                                                delete formErr.new_password;
                                                dispatch(changePasswordFailure(formErr));
                                            }
                                        }}
                                    />
                                    <div className={`${Styles.inputErr}`}>{formErr?.new_password?.[0] ? formErr.new_password[0] : null}</div>
                                </div>
                                {!userData?.user?.password_set ? <div className={`${Styles.changePasswordNote}`}>{t('Смена пароля недостпна согласно вашему методу регистрации')}!</div> : null}
                                <div
                                    className={`${isChangePasswordSuccess() ? Styles.ftfBorderBtn : Styles.ftfDisabledBtn}`}
                                    onClick={()=>{changePasswordHandler()}}
                                >
                                    {t('')}Change password
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Кошелек')}</div>
                            <div className={`${Styles.walletWrap}`}>
                                {userFriendlyAddress ? (
                                    <div className={`${Styles.walletWrapItem} ${userFriendlyAddress ? Styles.walletWrapItemConnected : null}`}>
                                        <div className={`${Styles.walletWrapItemTitle}`}>{t('Добавить кошелек')}:</div>
                                        <div className={`${Styles.walletWrapItemRow}`}>
                                            <div className={`${Styles.wallet} ${Styles.walletM}`}>{walletShorter(userFriendlyAddress)}</div>
                                            <div className={`${Styles.wallet} ${Styles.walletD}`}>{userFriendlyAddress}</div>
                                            <div className={`${Styles.ftfBorderBtn}`} onClick={() => { tonConnectUI.disconnect() }}>{t('Отключить')}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className={`${Styles.walletWrapItem} ${userFriendlyAddress ? Styles.walletWrapItemConnected : null}`}>
                                        <div className={`${Styles.walletWrapItemTitle}`}>{t('Добавить кошелек')}Add TON wallet:</div>
                                        <div className={`${Styles.ftfBorderBtn}`}>
                                            <TonConnectButton />
                                            {t('Подключить')}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetSettingsMain;